import { Controller } from "@hotwired/stimulus"

// Preview de imagen seleccionada en un file input.
// Muestra un thumbnail en un <img> target y oculta el placeholder.
//
// Targets:
//   input       — <input type="file"> (obligatorio)
//   preview     — <img> donde se muestra el preview (obligatorio)
//   placeholder — elemento que se oculta al seleccionar imagen (opcional)
//   dataUrl     — <input type="hidden"> donde se persiste el Data URL (opcional).
//                 Permite restaurar el preview tras un re-render del servidor
//                 (ej: validacion fallida que re-renderiza el partial via Turbo).
//
// Values:
//   autoSubmit  — Boolean (default false). Si true, hace submit del form
//                 asociado al file input al seleccionar archivo.
//
// Uso basico:
//   <div data-controller="manage--image-preview">
//     <input type="file" data-action="change->manage--image-preview#preview"
//            data-manage--image-preview-target="input">
//     <img data-manage--image-preview-target="preview" class="hidden">
//     <div data-manage--image-preview-target="placeholder">Upload icon</div>
//   </div>
//
// Con persistencia tras re-render:
//   <input type="hidden" data-manage--image-preview-target="dataUrl">
//
// Con auto-submit:
//   data-manage--image-preview-auto-submit-value="true"
export default class extends Controller {
  static targets = ["input", "preview", "placeholder", "dataUrl"]
  static values = { autoSubmit: { type: Boolean, default: false } }

  connect() {
    // Restaurar preview si hay un Data URL persistido (ej: tras validacion fallida)
    if (this.hasDataUrlTarget && this.dataUrlTarget.value) {
      this.showPreview(this.dataUrlTarget.value)
    }
  }

  preview() {
    const file = this.inputTarget.files[0]
    if (!file) return

    const reader = new FileReader()
    reader.onload = (e) => {
      const dataUrl = e.target.result
      this.showPreview(dataUrl)

      // Persistir Data URL en hidden para sobrevivir re-renders
      if (this.hasDataUrlTarget) {
        this.dataUrlTarget.value = dataUrl
      }
    }
    reader.readAsDataURL(file)

    if (this.autoSubmitValue) {
      this.#showLoading()
      this.submitAssociatedForm()
    }
  }

  // --- Private ---

  showPreview(src) {
    this.previewTarget.src = src
    this.previewTarget.classList.remove("hidden")
    if (this.hasPlaceholderTarget) {
      this.placeholderTarget.classList.add("hidden")
    }
  }

  submitAssociatedForm() {
    const input = this.inputTarget
    const formId = input.getAttribute("form")
    const form = formId ? document.getElementById(formId) : input.closest("form")
    if (form) form.requestSubmit()
  }

  #showLoading() {
    const wrapper = this.element
    wrapper.style.position = "relative"

    const overlay = document.createElement("div")
    overlay.className = "absolute inset-0 flex items-center justify-center bg-white/70 rounded-[6px] z-10"
    overlay.innerHTML = '<i class="fa-solid fa-spinner fa-spin text-[20px] text-[#999]"></i>'
    overlay.dataset.loadingOverlay = "true"

    wrapper.appendChild(overlay)
  }
}
